<template>
	<div class="page calculate-production-kgh">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<span class="navigation-title">{{$t('calculate-production-kgh')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prvent="calc" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="spindles-number">{{$t('spindles-number-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" id="spindles-number" v-model="spindlesNumber">
										</div>
									</div>
									<label for="production-speed">{{$t('production-speed-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" step="any" id="production-speed" v-model="productionSpeed">
										</div>
									</div>
									<label for="coefficient-of-performance">{{$t('coefficient-of-performance-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" step="any" id="coefficient-of-performance" v-model="coefficientOfPerformance">
										</div>
									</div>
									<label for="yarn-count">{{$t('yarn-count-?')}}</label>
									<div class="element">
										<div class="flex" data-cols="2">
											<select v-model="yarnCount.unit">
												<option
													v-for="(unit, index) in $yarnCountUtils.units"
													:key="'unit-'+index"
													:value="unit.code"
												>
													{{$t(unit.name)}}
												</option>
											</select>
											<input type="number" :placeholder="$t('yarn-count')" min="0" step="any" v-model="yarnCount.value" id="yarn-count">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<hr>
				<div class="container">
					<div class="content">
						<span class="result">{{result | unit}} {{$t('production-unit')}}</span>
						<!-- <button>{{$t('save')}}</button> -->
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			spindlesNumber: '',
			productionSpeed: '',
			coefficientOfPerformance: '',
			yarnCount: {
				unit: this.$settings.data.defaultYarnCount,
				value: ''
			},
			result: ''
		};
	},
	mounted() {
		this.calc();
	},
	watch: {
		spindlesNumber() {
			this.calc();
		},
		productionSpeed() {
			this.calc();
		},
		coefficientOfPerformance() {
			this.calc();
		},
		yarnCount: {
			handler () {
				this.calc();
			},
			deep: true
		}
	},
	methods: {
		calc() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			let spindlesNumber = this.$utils.sanitize(this.spindlesNumber);
			let productionSpeed = this.$utils.sanitize(this.productionSpeed);
			let coefficientOfPerformance = this.$utils.sanitize(this.coefficientOfPerformance);
			let yarnCountValue = this.$utils.sanitize(this.yarnCount.value);

			this.result = productionSpeed * spindlesNumber / this.$yarnCountUtils.convertToNm(this.yarnCount.unit, yarnCountValue) * coefficientOfPerformance * 60 / 1000;
			this.result = this.$utils.sanitize(this.result);
		}
	},
	filters: {
		unit(value) {
			value = value || 0;
			return value.toFixed(3);
		}
	}
}
</script>